module.exports = __webpack_public_path__ + "img/Frame 1.e1a1df57.png";